// src/services/cache.js - שירות Cache פשוט ויעיל + תמיכה במוצרים

class CacheService {
  constructor() {
    this.cache = new Map();
    this.CACHE_DURATION = {
      SEARCH: 5 * 60 * 1000,      // חיפוש - 5 דקות
      CATEGORY: 10 * 60 * 1000,   // קטגוריות - 10 דקות  
      STATISTICS: 30 * 60 * 1000, // סטטיסטיקות - 30 דקות
      PRODUCT: 15 * 60 * 1000,    // מוצרים בודדים - 15 דקות ✨ חדש
      SIMILAR: 20 * 60 * 1000,    // מוצרים דומים - 20 דקות ✨ חדש
      HEALTH: 2 * 60 * 1000,       // בדיקת בריאות - 2 דקות ✨ חדש
      TABLE: 20 * 60 * 1000        // 🚀 הוסף את זה - cache לטבלאות
    };
  }

  /**
   * 💾 שמירה בCache
   */
  set(key, data, duration = this.CACHE_DURATION.SEARCH) {
    const expiry = Date.now() + duration;
    const cacheItem = { data, expiry, timestamp: Date.now() };
    
    // שמירה בmemory
    this.cache.set(key, cacheItem);
    
    // שמירה בsessionStorage (בטוח יותר)
    try {
      sessionStorage.setItem(key, JSON.stringify(cacheItem));
    } catch (e) {
      console.warn('🔄 SessionStorage full, clearing old items');
      this.clearOldItems();
      try {
        sessionStorage.setItem(key, JSON.stringify(cacheItem));
      } catch (e2) {
        console.warn('💾 Could not save to cache:', e2);
      }
    }


  }

  /**
   * 📖 קריאה מCache
   */
  get(key) {
    // בדיקה בmemory cache
    let cached = this.cache.get(key);
    
    // אם לא נמצא, בדוק בsessionStorage
    if (!cached) {
      try {
        const stored = sessionStorage.getItem(key);
        if (stored) {
          cached = JSON.parse(stored);
          // החזר לmemory cache
          this.cache.set(key, cached);
        }
      } catch (e) {
        console.warn('📖 Error reading cache:', e);
        return null;
      }
    }

    // בדיקת תוקף
    if (cached && Date.now() < cached.expiry) {
      const age = Math.round((Date.now() - cached.timestamp) / 1000);
      
      return cached.data;
    }

    // מחיקת cache פג תוקף
    if (cached) {
     
      this.delete(key);
    }
    
    return null;
  }

  /**
   * 🗑️ מחיקה מCache
   */
  delete(key) {
    this.cache.delete(key);
    try {
      sessionStorage.removeItem(key);
    } catch (e) {
      // Silent fail
    }
  }

  /**
   * 🧹 ניקוי פריטים ישנים
   */
  clearOldItems() {
    try {
      const keys = Object.keys(sessionStorage);
      const now = Date.now();
      
      keys.forEach(key => {
        // הרחב את הפרפיקסים לכלול את הסוגים החדשים ✨
        if (key.startsWith('search_') || 
            key.startsWith('category_') || 
            key.startsWith('stats_') ||
            key.startsWith('product_') ||      // ✨ חדש
            key.startsWith('similar_') ||      // ✨ חדש
            key.startsWith('health_')) {       // ✨ חדש
          try {
            const item = JSON.parse(sessionStorage.getItem(key));
            if (now > item.expiry) {
              sessionStorage.removeItem(key);
            }
          } catch (e) {
            sessionStorage.removeItem(key); // מחק פריטים פגומים
          }
        }
      });
    } catch (e) {
      console.warn('🧹 Could not clear old items:', e);
    }
  }

  /**
   * 🔧 יצירת מפתח cache מתקדם ✨ מעודכן
   */
  createKey(type, params) {
    const baseKey = `${type}_`;
    
    switch (type) {
      case 'search':
        // search_term:category:limit
        return `${baseKey}${params.term}:${params.category || 'all'}:${params.limit || 20}`;
        
      case 'category':
        // category_categoryId:limit:sortBy
        return `${baseKey}${params.category}:${params.limit || 'all'}:${params.sortBy || 'default'}`;
        
      case 'stats':
        // stats_all או stats_specific
        return `${baseKey}${params}`;
        
      case 'health':
        // health_check
        return `${baseKey}${params}`;
        
      case 'product': // ✨ חדש
        // product_category:id
        return `${baseKey}${params.category}:${params.id}`;
        
      case 'similar': // ✨ חדש
        // similar_category:id:limit
        return `${baseKey}${params.category}:${params.id}:${params.limit || 6}`;
        case 'table': // 🆕 הוסף את זה
  // table_category:fundIds
  const sortedIds = Array.isArray(params.fundIds) 
    ? params.fundIds.sort((a,b) => a-b).join(',')
    : params.fundIds;
  return `${baseKey}${params.category}:${sortedIds}`;
      default:
        // fallback למבנה הישן
        const paramsStr = typeof params === 'object' ? JSON.stringify(params) : String(params);
        return `${baseKey}${paramsStr}`;
    }
  }

  /**
   * 🔍 חיפוש במטמון לפי תבנית ✨ חדש
   */
  findByPattern(pattern) {
    const results = [];
    
    // חיפוש בmemory cache
    for (const [key, entry] of this.cache.entries()) {
      if (key.includes(pattern) && Date.now() <= entry.expiry) {
        results.push({
          key,
          data: entry.data,
          age: Date.now() - entry.timestamp
        });
      }
    }
    
    // חיפוש בsessionStorage
    try {
      const keys = Object.keys(sessionStorage);
      const now = Date.now();
      
      keys.forEach(key => {
        if (key.includes(pattern) && !this.cache.has(key)) {
          try {
            const item = JSON.parse(sessionStorage.getItem(key));
            if (now <= item.expiry) {
              results.push({
                key,
                data: item.data,
                age: now - item.timestamp
              });
            }
          } catch (e) {
            // פריט פגום, דלג עליו
          }
        }
      });
    } catch (e) {
      console.warn('⚠️ Error searching in sessionStorage:', e);
    }
    
    return results;
  }

  /**
   * 🔍 חיפוש מוצר במטמון ✨ חדש
   */
  findProductInCache(productId, category = null) {
    // חיפוש ישיר
    if (category) {
      const directKey = this.createKey('product', { category, id: productId });
      const direct = this.get(directKey);
      if (direct) {
        
        return direct;
      }
    }

    // חיפוש בכל המוצרים השמורים
    const productPattern = 'product_';
    const allProducts = this.findByPattern(productPattern);
    
    for (const entry of allProducts) {
      if (entry.data && entry.data.id === productId.toString()) {
      
        return entry.data;
      }
    }


    return null;
  }

  /**
   * 🔍 מחיקה לפי תבנית ✨ חדש
   */
  deleteByPattern(pattern) {
    let deletedCount = 0;
    
    // מחיקה מmemory cache
    for (const key of this.cache.keys()) {
      if (key.includes(pattern)) {
        this.cache.delete(key);
        deletedCount++;
      }
    }
    
    // מחיקה מsessionStorage
    try {
      const keys = Object.keys(sessionStorage);
      keys.forEach(key => {
        if (key.includes(pattern)) {
          sessionStorage.removeItem(key);
          deletedCount++;
        }
      });
    } catch (e) {
      console.warn('⚠️ Error deleting from sessionStorage:', e);
    }
    
    
    return deletedCount;
  }

  /**
   * 📊 סטטיסטיקות Cache מעודכנות ✨
   */
  getStats() {
    const memorySize = this.cache.size;
    let sessionSize = 0;
    let totalSizeKB = 0;
    const typeBreakdown = {};
    
    try {
      const keys = Object.keys(sessionStorage);
      
      keys.forEach(key => {
        if (key.startsWith('search_') || 
            key.startsWith('category_') || 
            key.startsWith('stats_') ||
            key.startsWith('product_') ||    // ✨ חדש
            key.startsWith('similar_') ||    // ✨ חדש
            key.startsWith('health_')) {     // ✨ חדש
          
          sessionSize++;
          
          // חישוב גודל
          try {
            const itemSize = sessionStorage.getItem(key).length * 2; // כל תו = 2 bytes
            totalSizeKB += itemSize;
            
            // סיווג לפי סוג
            const type = key.split('_')[0];
            typeBreakdown[type] = (typeBreakdown[type] || 0) + 1;
          } catch (e) {
            // פריט פגום
          }
        }
      });
      
      totalSizeKB = Math.round(totalSizeKB / 1024); // המר ל-KB
      
    } catch (e) {
      console.warn('📊 Error calculating cache stats:', e);
    }

    return {
      memoryItems: memorySize,
      sessionItems: sessionSize,
      totalItems: memorySize + sessionSize,
      totalSizeKB: totalSizeKB,
      typeBreakdown: typeBreakdown,
      maxSessionStorageKB: 5120 // 5MB limit בדרך כלל
    };
  }

  /**
   * ⏰ ניקוי אוטומטי של פריטים שפג תוקפם ✨ חדש
   */
  cleanExpired() {
    let cleanedCount = 0;
    const now = Date.now();
    
    // ניקוי memory cache
    for (const [key, entry] of this.cache.entries()) {
      if (now > entry.expiry) {
        this.cache.delete(key);
        cleanedCount++;
      }
    }
    
    // ניקוי sessionStorage
    try {
      const keys = Object.keys(sessionStorage);
      keys.forEach(key => {
        if (key.startsWith('search_') || 
            key.startsWith('category_') || 
            key.startsWith('stats_') ||
            key.startsWith('product_') ||
            key.startsWith('similar_') ||
            key.startsWith('health_')) {
          try {
            const item = JSON.parse(sessionStorage.getItem(key));
            if (now > item.expiry) {
              sessionStorage.removeItem(key);
              cleanedCount++;
            }
          } catch (e) {
            // פריט פגום, מחק אותו
            sessionStorage.removeItem(key);
            cleanedCount++;
          }
        }
      });
    } catch (e) {
      console.warn('⚠️ Error during auto cleanup:', e);
    }
    
  
    
    return cleanedCount;
  }

  /**
   * 🔄 התחלת ניקוי אוטומטי ✨ חדש
   */
  startAutoCleanup(interval = 5 * 60 * 1000) { // כל 5 דקות
    setInterval(() => {
      this.cleanExpired();
    }, interval);
    
  
  }

  /**
   * 🗑️ ניקוי כל הCache
   */
  clear() {
    this.cache.clear();
    this.clearOldItems();
    
  }

  /**
   * 📋 רשימת כל המפתחות ✨ חדש
   */
  getAllKeys() {
    const allKeys = new Set();
    
    // מmemory cache
    for (const key of this.cache.keys()) {
      allKeys.add(key);
    }
    
    // מsessionStorage
    try {
      const keys = Object.keys(sessionStorage);
      keys.forEach(key => {
        if (key.startsWith('search_') || 
            key.startsWith('category_') || 
            key.startsWith('stats_') ||
            key.startsWith('product_') ||
            key.startsWith('similar_') ||
            key.startsWith('health_')) {
          allKeys.add(key);
        }
      });
    } catch (e) {
      console.warn('⚠️ Error getting keys from sessionStorage:', e);
    }
    
    return Array.from(allKeys);
  }
}

// יצירת instance יחיד
const cacheService = new CacheService();

// התחלת ניקוי אוטומטי (רק בדפדפן)
if (typeof window !== 'undefined') {
  cacheService.startAutoCleanup();
}

export default cacheService;